import { DEVICE_ROLES } from '@/features/core/container';
import { MetricResolutionAggregator, MetricResolutionTimeSource, SpotRole } from '@/types/iot-portal';
import { option } from '@/util/container';
import { component } from '../component';
import lg from './section-meter-water-meter-cold-lg.svg';
import md from './section-meter-water-meter-cold-md.svg';
import sm from './section-meter-water-meter-cold-sm.svg';

export default option(DEVICE_ROLES, async () => ({
  name: SpotRole.SECTION_METER_WATER_METER_COLD,
  label: 'Zwischenzähler_Kaltwasserzähler',
  shortLabel: 'Zs_Kaltw',
  icons: { sm, md, lg },
  component: component('section-meter-water-meter-cold/SectionMeterColdWaterMeterDevicePanel.vue'),
  aggregationWidget: {
    enabled: true,
    component: component('section-meter-water-meter-cold/SectionMeterColdWaterMeterAggregationWidget.vue'),
    props: { digitColor: 'BLUE' },
  },
  defaultMetricNames: ['currentVolume'],
  importantMetricNames: ['currentVolume'],
  aggregationMetricNames: [
    {
      name: 'currentVolume',
      aggregators: [MetricResolutionAggregator.MEAN],
      timeSource: MetricResolutionTimeSource.START,
    },
  ],
  consumption: true,
}));
